<template>
    <div class="index">
        <div class="box">
            <el-card class="head">
                <div class="date">
                    <h3>今天，</h3>
                    <p>{{ time }}</p>
                </div>
                <div class="list">
                    <div class="item">
                        <i class="iconfont icon-rukuguanli"></i>
                        <div class="count">
                            <p>25</p>
                            <span>待入库</span>
                        </div>
                    </div>
                    <div class="item">
                        <i class="iconfont icon-daishenhe"></i>
                        <div class="count">
                            <p>17</p>
                            <span>待审核</span>
                        </div>
                    </div>
                    <div class="item">
                        <i class="iconfont icon-tixian1"></i>
                        <div class="count">
                            <p>928.00</p>
                            <span>待提现</span>
                        </div>
                    </div>
                </div>
            </el-card>
        </div>

        <div class="main">
            <div class="main-left">
                <div class="main-left-top">
                    <div class="box">
                        <el-card class="new-people">
                            <div class="item">
                                <i class="iconfont icon-yusherenyuan"></i>
                                <div class="count">
                                    <p>2080<span>人</span></p>
                                    <span>今天新增人数</span>
                                </div>
                            </div>
                        </el-card>
                    </div>
                    <div class="box">
                        <el-card class="income">
                            <div class="item">
                                <i class="iconfont icon-shuju1"></i>
                                <div class="count">
                                    <p>28.50<span>元</span></p>
                                    <span>今天收益</span>
                                </div>
                            </div>
                        </el-card>
                    </div>
                </div>
                <div class="main-left-bottom">
                    <div class="box">
                        <el-card>
                            <div class="title"><p>订单数据</p></div>
                            <div id="myChart" style="width: 100%; height: 100px"></div>
                            <div class="chart">
                                <el-radio-group v-model="type" class="radio">
                                    <el-radio :label="1">累计</el-radio>
                                    <el-radio :label="2">新增</el-radio>
                                </el-radio-group>
                                <div id="myChart1" style="width: 100%; height: 400px; margin-top: 60px"></div>
                            </div>
                        </el-card>
                    </div>
                </div>
            </div>
            <div class="main-right">
                <div class="box">
                    <el-card>
                        <div class="title"><p>实时战报</p></div>
                        <div class="center">
                            <div class="chart">
                                <div class="icon">
                                    <el-image :src="imgUrl"></el-image>
                                    <div class="count">
                                        <p>59</p>
                                        <span>今天下单数</span>
                                    </div>
                                </div>
                                <div id="myChart2" style="width: 200px; height: 200px"></div>
                            </div>
                        </div>

                        <div class="table">
                            <el-table :data="tableData" ref="table" style="width: 100%">
                                <el-table-column prop="image" label="头像" align="center">
                                    <template slot-scope="scope">
                                        <el-image :src="scope.row.image" style="width: 40px; height: 40px"></el-image>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="date" label="时间" align="center"> </el-table-column>
                                <el-table-column prop="count" label="件数" align="center"> </el-table-column>
                                <el-table-column prop="price" label="价格" align="center"> </el-table-column>
                                <el-table-column prop="type" label="类型" align="center"> </el-table-column>
                                <el-table-column prop="goods_name" label="商品名称" align="center" width="320px"> </el-table-column>
                            </el-table>
                        </div>
                    </el-card>
                </div>
            </div>
        </div>
        <div class="box">
            <el-card class="foot">
                <div class="title">
                    <p>新品入库</p>
                </div>
                <div class="list">
                    <div class="item">
                        <div class="img">
                            <el-image
                                src="https://d1icd6shlvmxi6.cloudfront.net/gsc/3O9JOY/bc/86/8b/bc868bb0edf44c77a4a486d91fd60a37/images/%E9%A6%96%E9%A1%B5%E3%80%90%E4%BC%98%E5%8C%96%E5%BB%BA%E8%AE%AE%E3%80%91/u144.svg?token=6a4c455690f8a84424365ce39ea240e84d489b1d5e5b2b97c32f3e39aef85f85"
                            ></el-image>
                        </div>
                        <div class="price">
                            <p>￥12.82</p>
                            <span>预计收入1.80元</span>
                        </div>
                    </div>
                    <div class="item">
                        <div class="img">
                            <el-image
                                src="https://d1icd6shlvmxi6.cloudfront.net/gsc/3O9JOY/bc/86/8b/bc868bb0edf44c77a4a486d91fd60a37/images/%E9%A6%96%E9%A1%B5%E3%80%90%E4%BC%98%E5%8C%96%E5%BB%BA%E8%AE%AE%E3%80%91/u144.svg?token=6a4c455690f8a84424365ce39ea240e84d489b1d5e5b2b97c32f3e39aef85f85"
                            ></el-image>
                        </div>
                        <div class="price">
                            <p>￥12.82</p>
                            <span>预计收入1.80元</span>
                        </div>
                    </div>
                    <div class="item">
                        <div class="img">
                            <el-image
                                src="https://d1icd6shlvmxi6.cloudfront.net/gsc/3O9JOY/bc/86/8b/bc868bb0edf44c77a4a486d91fd60a37/images/%E9%A6%96%E9%A1%B5%E3%80%90%E4%BC%98%E5%8C%96%E5%BB%BA%E8%AE%AE%E3%80%91/u144.svg?token=6a4c455690f8a84424365ce39ea240e84d489b1d5e5b2b97c32f3e39aef85f85"
                            ></el-image>
                        </div>
                        <div class="price">
                            <p>￥12.82</p>
                            <span>预计收入1.80元</span>
                        </div>
                    </div>
                    <div class="item">
                        <div class="img">
                            <el-image
                                src="https://d1icd6shlvmxi6.cloudfront.net/gsc/3O9JOY/bc/86/8b/bc868bb0edf44c77a4a486d91fd60a37/images/%E9%A6%96%E9%A1%B5%E3%80%90%E4%BC%98%E5%8C%96%E5%BB%BA%E8%AE%AE%E3%80%91/u144.svg?token=6a4c455690f8a84424365ce39ea240e84d489b1d5e5b2b97c32f3e39aef85f85"
                            ></el-image>
                        </div>
                        <div class="price">
                            <p>￥12.82</p>
                            <span>预计收入1.80元</span>
                        </div>
                    </div>
                    <div class="item">
                        <div class="img">
                            <el-image
                                src="https://d1icd6shlvmxi6.cloudfront.net/gsc/3O9JOY/bc/86/8b/bc868bb0edf44c77a4a486d91fd60a37/images/%E9%A6%96%E9%A1%B5%E3%80%90%E4%BC%98%E5%8C%96%E5%BB%BA%E8%AE%AE%E3%80%91/u144.svg?token=6a4c455690f8a84424365ce39ea240e84d489b1d5e5b2b97c32f3e39aef85f85"
                            ></el-image>
                        </div>
                        <div class="price">
                            <p>￥12.82</p>
                            <span>预计收入1.80元</span>
                        </div>
                    </div>
                    <div class="item">
                        <div class="img">
                            <el-image
                                src="https://d1icd6shlvmxi6.cloudfront.net/gsc/3O9JOY/bc/86/8b/bc868bb0edf44c77a4a486d91fd60a37/images/%E9%A6%96%E9%A1%B5%E3%80%90%E4%BC%98%E5%8C%96%E5%BB%BA%E8%AE%AE%E3%80%91/u144.svg?token=6a4c455690f8a84424365ce39ea240e84d489b1d5e5b2b97c32f3e39aef85f85"
                            ></el-image>
                        </div>
                        <div class="price">
                            <p>￥12.82</p>
                            <span>预计收入1.80元</span>
                        </div>
                    </div>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
let echarts = require("echarts");
export default {
    data() {
        return {
            imgUrl: require("@/assets/img/u17.png"),
            time: "",
            type: 1,
            tableData: [
                {
                    image: "https://d1icd6shlvmxi6.cloudfront.net/gsc/3O9JOY/52/7c/48/527c488a5eb34d66b0111dea9c7c5a34/images/%E9%A6%96%E9%A1%B5%E3%80%90%E4%BC%98%E5%8C%96%E5%BB%BA%E8%AE%AE%E3%80%91/u20.svg?token=e535d695513df3ba18b07c9158648a7fa3370bd83f9741ff33ce3564de08bf4f",
                    date: "2021-11-4",
                    count: "购买5件",
                    price: "1.00",
                    type: "女装",
                    goods_name: "PC高档铝框拉杆箱TSA海关锁行李箱密码登机",
                },
                {
                    image: "https://d1icd6shlvmxi6.cloudfront.net/gsc/3O9JOY/52/7c/48/527c488a5eb34d66b0111dea9c7c5a34/images/%E9%A6%96%E9%A1%B5%E3%80%90%E4%BC%98%E5%8C%96%E5%BB%BA%E8%AE%AE%E3%80%91/u20.svg?token=e535d695513df3ba18b07c9158648a7fa3370bd83f9741ff33ce3564de08bf4f",
                    date: "2021-11-4",
                    count: "购买5件",
                    price: "1.00",
                    type: "女装",
                    goods_name: "PC高档铝框拉杆箱TSA海关锁行李箱密码登机",
                },
                {
                    image: "https://d1icd6shlvmxi6.cloudfront.net/gsc/3O9JOY/52/7c/48/527c488a5eb34d66b0111dea9c7c5a34/images/%E9%A6%96%E9%A1%B5%E3%80%90%E4%BC%98%E5%8C%96%E5%BB%BA%E8%AE%AE%E3%80%91/u20.svg?token=e535d695513df3ba18b07c9158648a7fa3370bd83f9741ff33ce3564de08bf4f",
                    date: "2021-11-4",
                    count: "购买5件",
                    price: "1.00",
                    type: "女装",
                    goods_name: "PC高档铝框拉杆箱TSA海关锁行李箱密码登机",
                },
                {
                    image: "https://d1icd6shlvmxi6.cloudfront.net/gsc/3O9JOY/52/7c/48/527c488a5eb34d66b0111dea9c7c5a34/images/%E9%A6%96%E9%A1%B5%E3%80%90%E4%BC%98%E5%8C%96%E5%BB%BA%E8%AE%AE%E3%80%91/u20.svg?token=e535d695513df3ba18b07c9158648a7fa3370bd83f9741ff33ce3564de08bf4f",
                    date: "2021-11-4",
                    count: "购买5件",
                    price: "1.00",
                    type: "女装",
                    goods_name: "PC高档铝框拉杆箱TSA海关锁行李箱密码登机",
                },
                {
                    image: "https://d1icd6shlvmxi6.cloudfront.net/gsc/3O9JOY/52/7c/48/527c488a5eb34d66b0111dea9c7c5a34/images/%E9%A6%96%E9%A1%B5%E3%80%90%E4%BC%98%E5%8C%96%E5%BB%BA%E8%AE%AE%E3%80%91/u20.svg?token=e535d695513df3ba18b07c9158648a7fa3370bd83f9741ff33ce3564de08bf4f",
                    date: "2021-11-4",
                    count: "购买5件",
                    price: "1.00",
                    type: "女装",
                    goods_name: "PC高档铝框拉杆箱TSA海关锁行李箱密码登机",
                },
                {
                    image: "https://d1icd6shlvmxi6.cloudfront.net/gsc/3O9JOY/52/7c/48/527c488a5eb34d66b0111dea9c7c5a34/images/%E9%A6%96%E9%A1%B5%E3%80%90%E4%BC%98%E5%8C%96%E5%BB%BA%E8%AE%AE%E3%80%91/u20.svg?token=e535d695513df3ba18b07c9158648a7fa3370bd83f9741ff33ce3564de08bf4f",
                    date: "2021-11-4",
                    count: "购买5件",
                    price: "1.00",
                    type: "女装",
                    goods_name: "PC高档铝框拉杆箱TSA海关锁行李箱密码登机",
                },
                {
                    image: "https://d1icd6shlvmxi6.cloudfront.net/gsc/3O9JOY/52/7c/48/527c488a5eb34d66b0111dea9c7c5a34/images/%E9%A6%96%E9%A1%B5%E3%80%90%E4%BC%98%E5%8C%96%E5%BB%BA%E8%AE%AE%E3%80%91/u20.svg?token=e535d695513df3ba18b07c9158648a7fa3370bd83f9741ff33ce3564de08bf4f",
                    date: "2021-11-4",
                    count: "购买5件",
                    price: "1.00",
                    type: "女装",
                    goods_name: "PC高档铝框拉杆箱TSA海关锁行李箱密码登机",
                },
                {
                    image: "https://d1icd6shlvmxi6.cloudfront.net/gsc/3O9JOY/52/7c/48/527c488a5eb34d66b0111dea9c7c5a34/images/%E9%A6%96%E9%A1%B5%E3%80%90%E4%BC%98%E5%8C%96%E5%BB%BA%E8%AE%AE%E3%80%91/u20.svg?token=e535d695513df3ba18b07c9158648a7fa3370bd83f9741ff33ce3564de08bf4f",
                    date: "2021-11-4",
                    count: "购买5件",
                    price: "1.00",
                    type: "女装",
                    goods_name: "PC高档铝框拉杆箱TSA海关锁行李箱密码登机",
                },
                {
                    image: "https://d1icd6shlvmxi6.cloudfront.net/gsc/3O9JOY/52/7c/48/527c488a5eb34d66b0111dea9c7c5a34/images/%E9%A6%96%E9%A1%B5%E3%80%90%E4%BC%98%E5%8C%96%E5%BB%BA%E8%AE%AE%E3%80%91/u20.svg?token=e535d695513df3ba18b07c9158648a7fa3370bd83f9741ff33ce3564de08bf4f",
                    date: "2021-11-4",
                    count: "购买5件",
                    price: "1.00",
                    type: "女装",
                    goods_name: "PC高档铝框拉杆箱TSA海关锁行李箱密码登机",
                },
                {
                    image: "https://d1icd6shlvmxi6.cloudfront.net/gsc/3O9JOY/52/7c/48/527c488a5eb34d66b0111dea9c7c5a34/images/%E9%A6%96%E9%A1%B5%E3%80%90%E4%BC%98%E5%8C%96%E5%BB%BA%E8%AE%AE%E3%80%91/u20.svg?token=e535d695513df3ba18b07c9158648a7fa3370bd83f9741ff33ce3564de08bf4f",
                    date: "2021-11-4",
                    count: "购买5件",
                    price: "1.00",
                    type: "女装",
                    goods_name: "PC高档铝框拉杆箱TSA海关锁行李箱密码登机",
                },
            ],
        };
    },
    mounted() {
        const table = this.$refs.table;
        // 拿到表格中承载数据的div元素
        const divData = table.bodyWrapper;
        // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
        setInterval(() => {
            // 元素自增距离顶部1像素
            divData.scrollTop += 1;
            // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
            if (divData.clientHeight + divData.scrollTop == divData.scrollHeight) {
                // 重置table距离顶部距离
                divData.scrollTop = 0;
            }
        }, 100);
    },
    created() {
        this.getTime();
        this.$nextTick(() => {
            this.drawLine();
            this.drawLine1();
            this.drawLine2();
        });
    },
    methods: {
        getTime() {
            let yy = new Date().getFullYear();
            let mm = new Date().getMonth() + 1 < 10 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1;
            let dd = new Date().getDate() < 10 ? "0" + new Date().getDate() : new Date().getDate();
            var gettime = `${yy}年${mm}月${dd}日`;
            //当前星期
            let wk = new Date().getDay();
            let weeks = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
            let week = weeks[wk];
            this.time = `${gettime}${week}，欢迎您回到后台操作系统`;
        },
        drawLine2() {
            let myChart = echarts.init(document.getElementById("myChart2"), "light");
            const handred = 100;
            let point = 16;

            let option = {
                title: {
                    text: point + "%",
                    x: "center",
                    y: "center",
                    textStyle: {
                        fontWeight: "normal",
                        color: "#5d73d4",
                        fontSize: "24",
                    },
                    subtext: "下单转化率",
                    subtextStyle: {
                        color: "#B1B1B1",
                        fontSize: 14,
                    },
                    itemGap: 10,
                    left: "center",
                    top: "43%",
                },
                tooltip: {
                    formatter: function (params) {
                        return params.name + "：" + params.percent + " %";
                    },
                },
                series: [
                    {
                        name: "circle",
                        type: "pie",
                        clockWise: true,
                        radius: ["75%", "95%"],
                        itemStyle: {
                            normal: {
                                label: {
                                    show: false,
                                },
                                labelLine: {
                                    show: false,
                                },
                            },
                        },
                        hoverAnimation: false,
                        data: [
                            {
                                value: point,
                                name: "占比",
                                itemStyle: {
                                    normal: {
                                        color: {
                                            // 颜色渐变
                                            colorStops: [
                                                {
                                                    offset: 0,
                                                    color: "#283fae", // 0% 处的颜色
                                                },
                                                {
                                                    offset: 1,
                                                    color: "#5d73d4", // 100% 处的颜色1
                                                },
                                            ],
                                        },
                                        label: {
                                            show: false,
                                        },
                                        labelLine: {
                                            show: false,
                                        },
                                    },
                                },
                            },
                            {
                                name: "剩余",
                                value: handred - point,
                                itemStyle: {
                                    normal: {
                                        color: "#E1E8EE",
                                    },
                                },
                            },
                        ],
                    },
                ],
            };
            myChart.setOption(option, true);
        },
        drawLine1() {
            // 基于准备好的dom，初始化echarts实例
            let myChart = echarts.init(document.getElementById("myChart1"), "light");
            let option = {
                title: {
                    text: "每日订单",
                    textStyle: {
                        fontSize: 14,
                        color: "#333",
                        fontWeight: "normal",
                    },
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                    },
                },
                grid: {
                    left: 20,
                    bottom: 20,
                    right: 20,
                    containLabel: true,
                },
                xAxis: [
                    {
                        type: "category",
                        data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
                        axisTick: {
                            alignWithLabel: true,
                        },
                    },
                ],
                yAxis: [
                    {
                        type: "value",
                    },
                ],
                series: [
                    {
                        name: "Direct",
                        type: "bar",
                        barWidth: "16",
                        data: [10, 52, 200, 334, 390, 330, 220],
                        itemStyle: {
                            normal: {
                                barBorderRadius: [8, 8, 0, 0],
                                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                                    {
                                        offset: 0,
                                        color: "#fff",
                                    },
                                    {
                                        offset: 1,
                                        color: "#5d73d4",
                                    },
                                ]),
                            },
                        },
                    },
                ],
            };
            myChart.setOption(option, true);
        },
        drawLine() {
            // 基于准备好的dom，初始化echarts实例
            let myChart = echarts.init(document.getElementById("myChart"), "light");
            var echartData = [
                {
                    name: "累计订单总数",
                    data: [236],
                },
                {
                    name: "昨日新增订单",
                    data: [152],
                },
            ];

            var option = {
                backgroundColor: "#fff",
                grid: {
                    left: 20,
                    bottom: 0,
                    right: 20,
                },
                tooltip: {
                    //提示
                    trigger: "item",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "line", // 默认为直线，可选为：'line' | 'shadow'
                        label: {
                            show: false,
                        },
                    },
                },
                xAxis: {
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                    axisLabel: {
                        show: false,
                    },
                },
                yAxis: {
                    data: ["数量"],
                    axisLabel: {
                        show: false,
                    },
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                },
                series: [],
            };

            echartData.forEach((item, index) => {
                option.series.push({
                    type: "bar",
                    stack: "sum",
                    barWidth: 50,
                    name: item.name,
                    data: item.data,
                    label: {
                        normal: {
                            show: true,
                            position: [10, -38],
                            formatter: "{a|" + item.name + "}\n\n\n\n{b|" + item.data + "} {c|" + "" + "}",
                            align: "left",
                            textStyle: {
                                color: "#fff",
                                rich: {
                                    a: {
                                        fontSize: "14",
                                        fontWeight: 500,
                                        color: "#333",
                                    },
                                    b: {
                                        fontSize: "20",
                                        fontWeight: 500,
                                        color: "#fff",
                                    },
                                    c: {
                                        fontSize: "14",
                                        fontWeight: 500,
                                        color: "#fff",
                                    },
                                },
                            },
                        },
                    },
                });
                if (index === 0) {
                    option.series[index].itemStyle = {
                        normal: {
                            barBorderRadius: [8, 0, 0, 8],
                            color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                                {
                                    offset: 0,
                                    color: "#283fae",
                                },
                                {
                                    offset: 1,
                                    color: "#5d73d4",
                                },
                            ]),
                        },
                    };
                } else if (index === echartData.length - 1) {
                    option.series[index].itemStyle = {
                        normal: {
                            barBorderRadius: [0, 8, 8, 0],
                            color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                                {
                                    offset: 0,
                                    color: "#ffbe31",
                                },
                                {
                                    offset: 1,
                                    color: "#ffc954",
                                },
                            ]),
                        },
                    };
                } else {
                    return;
                }
            });
            // 绘制图表
            myChart.setOption(option, true);
        },
    },
};
</script>

<style lang="scss" scoped>
.index {
    padding: 20px;
    .head {
        ::v-deep .el-card__body {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .date {
                color: #333;
                h3 {
                    font-size: 24px;
                    font-weight: normal;
                    margin-bottom: 10px;
                }
                p {
                    font-size: 18px;
                }
            }
            .list {
                display: flex;
                .item {
                    display: flex;
                    align-items: center;
                    margin-left: 60px;
                    text-align: left;
                    color: #333;
                    i {
                        font-size: 42px;
                        color: #1c35b3;
                        margin-right: 8px;
                    }
                    .count {
                        p {
                            font-size: 24px;
                            line-height: 24px;
                            font-weight: 600;
                        }
                        span {
                            font-size: 14px;
                            color: #666;
                        }
                    }
                }
            }
        }
    }
    .main {
        display: flex;
        justify-content: space-between;
        height: 811px;
        .main-left {
            width: 50%;
            .main-left-top {
                display: flex;
                justify-content: space-between;
                .box {
                    width: 50%;
                }
                .new-people,
                .income {
                    padding: 20px 10px;
                    height: 100%;
                    .item {
                        display: flex;
                        text-align: left;
                        align-items: center;
                        justify-content: center;
                        color: #333;
                        width: 100%;
                        i {
                            font-size: 46px;
                            color: #1c35b3;
                            margin-right: 20px;
                        }
                        .count {
                            p {
                                font-weight: 600;
                                font-size: 24px;
                                span {
                                    margin-left: 8px;
                                    font-size: 14px;
                                }
                            }
                            span {
                                font-size: 14px;
                                color: #666;
                                line-height: 16px;
                            }
                        }
                    }
                }
            }
        }
        .main-right {
            .box {
                .table {
                    margin-top: 20px;
                }
                height: 100%;
                .center {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .chart {
                        width: 100%;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        .icon {
                            display: flex;
                            text-align: left;
                            align-items: center;
                            color: #333;
                            .count {
                                p {
                                    font-weight: 600;
                                    font-size: 36px;
                                    span {
                                        margin-left: 8px;
                                        font-size: 14px;
                                    }
                                }
                                span {
                                    font-size: 14px;
                                    color: #666;
                                    line-height: 16px;
                                }
                            }
                        }
                    }
                }
            }
            width: 50%;
            min-height: 100%;
            .el-card {
                height: 100%;
            }
        }
    }
    .el-card {
        .title {
            font-size: 16px;
            color: #333;
            position: relative;
            padding-left: 14px;
            margin-bottom: 20px;
            p {
                font-weight: 600;
            }
            &::before {
                content: "";
                position: absolute;
                left: 0;
                top: 50%;
                width: 3px;
                height: 16px;
                background: #ffc306;
                transform: translateY(-50%);
            }
        }
    }
    .box {
        padding: 10px;
    }
    .foot {
        .list {
            display: flex;
            justify-content: space-between;
            .img {
                width: 190px;
                height: 190px;
            }
            .price {
                text-align: center;
                color: #333;
                font-weight: 600;
                p {
                    font-size: 24px;
                }
                span {
                    font-size: 14px;
                }
            }
        }
    }
}
.chart {
    position: relative;
    .radio {
        position: absolute;
        top: 10px;
        right: 20px;
        z-index: 1;
    }
}
::v-deep .el-table th.el-table__cell.is-leaf {
    border-bottom: 2px solid rgba(33, 61, 192, 1);
}
::v-deep .el-table__body {
    animation: myfirst 12s linear infinite;
    animation-play-state: running;
    &:hover {
        animation-play-state: paused;
    }
}
@keyframes myfirst {
    from {
        transform: translateY(0%);
    }
    to {
        transform: translateY(-70%);
    }
}
// @-webkit-keyframes myfirst /* Safari and Chrome */ {
//     from {
//         transform: translateY(0);
//     }
//     to {
//         transform: translateY(100%);
//     }
// }
</style>